import Component from '@glimmer/component';
import UserDocumentListItem from 'garaje/components/user-document-list/item';
import type UserDocumentModel from 'garaje/models/user-document';

interface UserDocumentListSignature {
  Args: {
    userDocuments?: UserDocumentModel[];
  };
  Element: HTMLTableElement;
}

export default class UserDocumentList extends Component<UserDocumentListSignature> {
  get sortedUserDocumentList(): UserDocumentModel[] {
    const docs = this.args.userDocuments;
    if (!docs?.length) return [];
    return [...docs].sort((a, b) => {
      const aTime = new Date(a.sortableDate).getTime() || 0;
      const bTime = new Date(b.sortableDate).getTime() || 0;
      return bTime - aTime;
    });
  }

  <template>
    <table ...attributes>
      {{#each this.sortedUserDocumentList as |userDocument|}}
        <UserDocumentListItem @userDocument={{userDocument}} />
      {{/each}}
    </table>
  </template>
}
